import { render, staticRenderFns } from "./SuggestionInput.vue?vue&type=template&id=7ea004ae"
import script from "./SuggestionInput.vue?vue&type=script&lang=js"
export * from "./SuggestionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports